import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';

function CapitalizeFirstLetter(str) {
  return str.replace(/_/g, " ").replace(/\b\w/g, function (l) {
    return l.toUpperCase();
  });
}

function IntroPage() {
  const logo = process.env.PUBLIC_URL + 'BandScannerLogoSquareSemiTrans.png';
  const [databases, setDatabases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDatabases = async () => {
      try {
        // First, try to fetch from metadata collection if it exists
        const metadataRef = firebase.firestore().collection('_metadata').doc('databases');
        const metadataDoc = await metadataRef.get();
        
        if (metadataDoc.exists) {
          const data = metadataDoc.data();
          if (data && data.collections && Array.isArray(data.collections)) {
            // Sort alphabetically
            const sorted = [...data.collections].sort((a, b) => {
              const aName = CapitalizeFirstLetter(a);
              const bName = CapitalizeFirstLetter(b);
              return aName.localeCompare(bName);
            });
            setDatabases(sorted);
            setLoading(false);
            return;
          }
        }

        // Fallback: Try to get collections by checking known collections
        // This is a workaround since client SDK can't list all collections
        // You should maintain a _metadata/databases document with a 'collections' array
        // For now, fallback to hardcoded list but fetch dynamically if possible
        const knownCollections = ['oxford', 'bristol', 'newcastle+upon+tyne'];
        
        // Verify which collections actually exist by checking if they have documents
        const existingCollections = [];
        for (const collName of knownCollections) {
          try {
            const collRef = firebase.firestore().collection(collName);
            const snapshot = await collRef.limit(1).get();
            if (!snapshot.empty) {
              existingCollections.push(collName);
            }
          } catch (error) {
            console.warn(`Error checking collection ${collName}:`, error);
          }
        }
        
        // Sort alphabetically
        const sorted = existingCollections.sort((a, b) => {
          const aName = CapitalizeFirstLetter(a);
          const bName = CapitalizeFirstLetter(b);
          return aName.localeCompare(bName);
        });
        
        setDatabases(sorted);
      } catch (error) {
        console.error('Error fetching databases:', error);
        // Fallback to known collections on error
        const fallback = ['oxford', 'bristol', 'newcastle+upon+tyne'].sort((a, b) => {
          const aName = CapitalizeFirstLetter(a);
          const bName = CapitalizeFirstLetter(b);
          return aName.localeCompare(bName);
        });
        setDatabases(fallback);
      } finally {
        setLoading(false);
      }
    };

    fetchDatabases();
  }, []);

  return (
    <div className="intro-page">
      <div className="logo-scan-parent">
        <div className="logo-container">
          <img src={logo} alt="logo"/>
        </div>  
        <div className="circle-container">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
      </div>
      <div className="tagline">Your go-to source for discovering new music!</div>
      <div className="intro-links">
        {loading ? (
          <div style={{ color: '#fafafafa', fontFamily: 'Harvest' }}>Loading databases...</div>
        ) : (
          <ul>
            {databases.map((dbName) => (
              <li key={dbName}>
                <a href={`/${encodeURIComponent(dbName)}`} className="intro-link">
                  {CapitalizeFirstLetter(dbName)}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="email">Contact: <a href="mailto:blackwhippy@gmail.com">blackwhippy@gmail.com</a></div>
    </div>
  );
}

export default IntroPage;